export default __webpack_public_path__ + "static/media/Wrap of the Endless Sands.f6d02dba.jpg";